module.exports = __webpack_public_path__ + "static/media/tertiary-rectangle.7d082b3a.svg";